/**
 * Area-tree walkers for ScopeTreeTable, moved out of it (god-file ratchet)
 * when PRP-MCP-5 added the "from chat" tags.
 */
import type { TreeNode } from '../components/ScopeTreeTable';

/** Recursively collect the leaf node ids beneath a tree node. */
export function leavesUnder(node: TreeNode): string[] {
  return node.children ? node.children.flatMap(leavesUnder) : [node.id];
}

/** Depth-first search for a node by id within a tree. */
export function findNode(nodes: TreeNode[], id: string): TreeNode | null {
  for (const n of nodes) {
    if (n.id === id) return n;
    if (n.children) {
      const f = findNode(n.children, id);
      if (f) return f;
    }
  }
  return null;
}
